import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { model as config, remote } from '@/config'
import { logger } from '@/logger'
import {
  attach,
  combine,
  createEvent,
  createStore,
  sample,
  type Store,
} from 'effector'
import { openWindow } from '~/core/router'
import type { PartnerProductDetailsFormatted } from '~/entities/partner-product'

export const selectGoToApp = createEvent<{
  partnerProduct: PartnerProductDetailsFormatted
}>()

const resetSelectedGoToApp = createEvent()

const $selectedGoToApp = createStore<PartnerProductDetailsFormatted | null>(
  null
)
  .on(selectGoToApp, (_, selectedItem) => selectedItem.partnerProduct)
  .reset(resetSelectedGoToApp)

const closePopup = createEvent()
const $isPopupOpened = $selectedGoToApp.map(Boolean)

const $addRefererFor: Store<string> = config.get(
  remote.tria_addRefererForPartnerProductProvider,
  ''
)

const goToApp = createEvent<string>()
const goToAppFx = attach({
  source: { addRefererFor: $addRefererFor, app: $selectedGoToApp },
  effect({ addRefererFor, app }) {
    const type = app?.partnersProgramType
    if (type !== 'REDIRECT') {
      throw new Error(`Unsupported partner program type: ${type}`)
    }

    const url = app?.purchaseInfo?.partnerProductLink
    if (!url) {
      throw new Error('Empty partnerProductLink')
    }

    const provider = app.partnerProvider
    const providers = addRefererFor.split(';')
    const addReferer = providers.some((p) => p === provider)

    return openWindow(
      url,
      'partner_program',
      addReferer ? undefined : 'noreferrer'
    )
  },
})

sample({
  clock: goToApp,
  target: goToAppFx,
})

sample({
  clock: goToAppFx.done,
  target: closePopup,
})
sample({
  clock: goToAppFx.failData,
  fn: (error) => ['failed to open shopping cart window', error],
  target: logger.errorFx,
})

sample({
  clock: closePopup,
  target: resetSelectedGoToApp,
})

const $partnerProgramPopupTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('go_to_app_header'),
  description: t('go_to_app_description'),
  button: t('go_to_app'),
}))

register(closePopup, 'payment/partner/go/closePopup')
register(goToApp, 'payment/partner/go/goToApp')
register($isPopupOpened, '$payment/partner/go/isPopupOpened')
register(
  $partnerProgramPopupTranslations,
  '$payment/partner/go/partnerProgramPopupTranslations'
)
